import axios from "axios";
const apiURL = process.env.REACT_APP_API_URL;

// Helper to get user ID from JWT
const getUserId = () => {
  const jwt = localStorage.getItem("jwt");
  if (jwt) {
    const parsed = JSON.parse(jwt);
    return parsed.user?._id || null;
  }
  return null;
};

export const isWish = (id, wList) => {
  if (wList !== null && wList.includes(id) === true) {
    return true;
  }
  return false;
};

export const isWishReq = async (e, id, setWlist) => {
  let list = localStorage.getItem("wishList")
    ? JSON.parse(localStorage.getItem("wishList"))
    : [];

  if (!list.includes(id)) {
    list.push(id);
    localStorage.setItem("wishList", JSON.stringify(list));
    setWlist(list);
  }

  // If user is logged in, also save to database
  const userId = getUserId();
  if (userId) {
    try {
      await axios.post(`${apiURL}/api/user/wishlist/add`, {
        uId: userId,
        productId: id,
      });
    } catch (error) {
      console.log("Error saving to database wishlist:", error);
    }
  }
};

export const unWishReq = async (e, id, setWlist) => {
  let list = localStorage.getItem("wishList")
    ? JSON.parse(localStorage.getItem("wishList"))
    : [];

  if (list.includes(id)) {
    list.splice(list.indexOf(id), 1);
    localStorage.setItem("wishList", JSON.stringify(list));
    setWlist(list);
  }

  // If user is logged in, also remove from database
  const userId = getUserId();
  if (userId) {
    try {
      await axios.post(`${apiURL}/api/user/wishlist/remove`, {
        uId: userId,
        productId: id,
      });
    } catch (error) {
      console.log("Error removing from database wishlist:", error);
    }
  }
};

// Sync wishlist from database on login
export const syncWishlistFromDB = async (setWlist) => {
  const userId = getUserId();
  if (!userId) return;

  try {
    // Get local wishlist
    const localWishlist = localStorage.getItem("wishList")
      ? JSON.parse(localStorage.getItem("wishList"))
      : [];

    // Sync with database (merge local and database wishlists)
    const res = await axios.post(`${apiURL}/api/user/wishlist/sync`, {
      uId: userId,
      localWishlist: localWishlist,
    });

    if (res.data.wishlist) {
      // Update localStorage with merged wishlist
      localStorage.setItem("wishList", JSON.stringify(res.data.wishlist));
      if (setWlist) {
        setWlist(res.data.wishlist);
      }
    }
  } catch (error) {
    console.log("Error syncing wishlist:", error);
  }
};

export const nextSlide = (totalImg, slide, setSlide) => {
  if (slide === totalImg - 1) {
    setSlide(0);
  } else if (slide < totalImg) {
    setSlide(slide + 1);
  }
};

export const prevSlide = (totalImg, slide, setSlide) => {
  if (slide === 0) {
    setSlide(totalImg - 1);
  } else if (slide === totalImg - 1) {
    setSlide(0);
  }
};
